import { getConfig } from "./featureSwitch";
const configs = {
    vbp: 'off',
    bkw: 'on',
    twente: 'on',
    aanzet: 'off',
    dnb: 'off',
    flevo: 'off',
    rdam: 'off'
};
export const branchLocalization = getConfig(configs);
